import { useIsSkincare } from 'hooks/useIsSkincare';

import { FOOTER_FDA_DISCLAIMER, FOOTER_REFERENCES } from './constants';

export type DisclaimerContent = {
  fdaDisclaimer: string;
  references: string;
};

export const useDisclaimers = (): DisclaimerContent | null => {
  if (useIsSkincare()) {
    return null;
  }

  return {
    fdaDisclaimer: FOOTER_FDA_DISCLAIMER,
    references: FOOTER_REFERENCES,
  };
};
